import React from 'react';
import { Link } from 'react-router-dom';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import { Button, IconButton, FormControl, Paper, Slide, Typography,
  withStyles, Select, MenuItem, FormLabel } from '@material-ui/core';
import AspectRatio from '@material-ui/icons/AspectRatio';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import PictureAsPdf from '@material-ui/icons/PictureAsPdf';
import VariantSnackbar from '../share/VariantSnackbar';
import { inject, observer } from 'mobx-react';
import FilterBeneficiario from '../share/FilterBeneficiario';
import { format, isAfter, subMonths } from 'date-fns';
import FullScreenRelatorioReembolso from './FullScreenRelatorioReembolso';
import FullScreenRelatorioReembolsoExport from './FullScreenRelatorioReembolsoExport';

const styles = theme => ({
  searchIcon: {
    marginRight: theme.spacing.unit,
  },
  button: {
    margin: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
  link: {
    textDecoration: 'none',
  },
  body: {
    backgroundColor: '#EDEDEE',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    height: theme.spacing.unit * 40,
  },
  iconButton: {
    marginBottom: theme.spacing.unit,
  },
  invisible: {
    display: 'none',
  },
  formControl: {
  },
  selectMesAno: {
    marginLeft: theme.spacing.unit * 2,
  },
  formControlAutoCompleteBenef: {
    minWidth: 300,
    marginLeft: theme.spacing.unit * 2,
  },
  divCampos: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end'
  },  
  marginRight: {
    marginRight: theme.spacing.unit,
  },
  marginLeft: {
    marginLeft: theme.spacing.unit,
  },
});
@inject('aplicacaoStore')
@observer
class Reembolso extends React.Component {
  state = {
    reembolsos: [],
    nomesBeneficiarios: [],
    anosBase: [],
    filtro: {},
    carteiraSelected: '',
    nomeBeneficiarioSelected: '',
    anoBaseSelected: 0,
    fetching: false,
    fetchingInicio: true,
    snackOpen: false,
    snackVariant: 'success',
    snackHorizontal: 'right',
    snackMessage: '',
    sucesso: true,
    fullScreenPrintOpen: false,
    fullScreenExportOpen: false,
    datasDeReferencia: [],
    mesAno: format(new Date(), 'MM/YYYY'),
}

  getListaDatasReferencia () {
    let dataInicial = new Date(2013, 12, 1);
    let dataAtual = new Date();
    let resultado = [];
    while (isAfter(dataAtual, dataInicial)) {
      let registro = format(new Date(dataAtual), 'MM/YYYY');
      resultado.push(registro);
      dataAtual = subMonths(dataAtual, 1);
    }
    this.setState({datasDeReferencia: resultado});
  }

  componentDidMount = async () => {
    await this.consultarNomesBeneficiarios();
    this.getListaDatasReferencia();
    this.setState({fetchingInicio: false});
  }

  consultarNomesBeneficiarios = async () => {
    const nomesBeneficiarios = await this.props.aplicacaoStore.getBeneficiarios();
    this.setState({ nomesBeneficiarios: nomesBeneficiarios });
  }

  handleClickBuscar = async () => {    
    const filtro = {
      codServidor: this.state.carteiraSelected === '' ? 0 : Number(this.state.carteiraSelected.substring(0, 5)),
      ano: Number(this.state.mesAno.substring(3, 7)),
      mes: Number(this.state.mesAno.substring(0, 2)),
      };
    this.setState({fullScreenPrintOpen: true, filtro: filtro});
  }
  handleChange = event => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }
  handleClickLimpar = async () => {
    this.setState({
      carteiraSelected: '',
      nomeBeneficiarioSelected: ''
    });
  }
  handleSelectBeneficiario = (carteira, nome) => {
    this.setState({
      carteiraSelected: carteira,
      nomeBeneficiarioSelected: nome
    });
  }
  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  }
  handleCloseFullScreenPrint = () => {
    this.setState({ fullScreenPrintOpen: false });
  }
  handleCloseFullScreenExport = () => {
    this.setState({ fullScreenExportOpen: false });
  }
  handleClickExport = () => {
    const filtro = {
      codServidor: this.state.carteiraSelected === '' ? 0 : Number(this.state.carteiraSelected.substring(0, 5)),
      ano: Number(this.state.mesAno.substring(3, 7)),
      mes: Number(this.state.mesAno.substring(0, 2)),
      };
    this.setState({ fullScreenExportOpen: true, filtro: filtro });
  }

  render () {
    const { classes } = this.props;
    const { fetchingInicio, fetching, mesAno, datasDeReferencia } = this.state;
    return (
      <React.Fragment>
        <Link to='/relatorio' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Relatório de Reembolsos</Typography>
            </Paper>
          </Slide>
        </Link>
        {fetchingInicio || fetching ? <LinearProgressBlockScreen />
          : <div>
              <Paper className={classes.body} elevation={1}>
              <div className={classes.divCampos}>
              <FormControl component='filedset' className={classes.selectMesAno}>
                <FormLabel component='legend'>Mês de Referência</FormLabel>
                <Select
                  value={mesAno}
                  onChange={this.handleChange}
                  inputProps={{
                  name: 'mesAno',
                  }}
                >
                {datasDeReferencia.map(anoRef => {
                  return (<MenuItem key={anoRef} value={anoRef}>{anoRef}</MenuItem>);
                })}
              </Select>
            </FormControl>
              <FormControl component='filedset' className={classes.formControlAutoCompleteBenef}>
                <FilterBeneficiario
                  beneficiarios={this.state.nomesBeneficiarios}
                  handleSelectBeneficiario={this.handleSelectBeneficiario}
                  handleClickLimpar={this.handleClickLimpar} />
              </FormControl>
              <Button
              size='small'
              variant='contained'
              color='primary'
              title='Visualizar'
              type='submit'
              onClick={this.handleClickBuscar}
              className={classes.marginLeft}>
              <PictureAsPdf className={classes.marginRight} />
              Visualizar PDF
            </Button>
            <Button
              size='small'
              color='secondary'
              variant='contained'
              title='Exportar para planilha'
              type='submit'
              onClick={this.handleClickExport}
              className={classes.marginLeft}>
              <AspectRatio className={classes.marginRight} />
              Gerar Excel
            </Button>
              </div>
            </Paper>          
          </div>
        }
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.sucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />
        {this.state.fullScreenPrintOpen &&
        <FullScreenRelatorioReembolso
          open={this.state.fullScreenPrintOpen}
          handleClose={this.handleCloseFullScreenPrint}
          nomeTitular={this.state.nomeBeneficiarioSelected}
          filtro={this.state.filtro}
          mesAno={this.state.mesAno}
        />}
        {this.state.fullScreenExportOpen &&
        <FullScreenRelatorioReembolsoExport
          open={this.state.fullScreenExportOpen}
          handleClose={this.handleCloseFullScreenExport}
          nomeTitular={this.state.nomeBeneficiarioSelected}
          filtro={this.state.filtro}
          mesAno={this.state.mesAno}
        />}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(Reembolso);
